import React from 'react';
import QRCode from 'react-qr-code';

const QrCodeGenerator = ({ value, size }) => <QRCode value={value} size={size} />;

export default QrCodeGenerator;
